import { useEffect, useRef } from 'react';
import { carregarGoogleMaps } from '../../lib/googleMaps';

// Mesmo contrato do MapaLeaflet (latitude, longitude, aoMudar): clicar no mapa ou arrastar o marcador
// preenche as coordenadas. `aoFalhar` é chamado se o Google não carregar/recusar a chave (o wrapper cai
// no OpenStreetMap).
const CENTRO_PADRAO = { lat: -22.5837903, lng: -47.4097539 };

export default function MapaGoogle({ chave, latitude, longitude, aoMudar, aoFalhar }) {
  const divRef = useRef(null);
  const mapaRef = useRef(null);
  const marcadorRef = useRef(null);
  const aoMudarRef = useRef(aoMudar);
  aoMudarRef.current = aoMudar;

  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  const temPonto = Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);

  useEffect(() => {
    let vivo = true;
    carregarGoogleMaps(chave)
      .then((maps) => {
        if (!vivo || !divRef.current) return;
        const inicio = temPonto ? { lat, lng } : CENTRO_PADRAO;
        const mapa = new maps.Map(divRef.current, {
          center: inicio,
          zoom: temPonto ? 17 : 13,
          streetViewControl: false,
          mapTypeControl: true,
        });
        const marcador = new maps.Marker({ position: inicio, map: temPonto ? mapa : null, draggable: true });
        marcador.addListener('dragend', () => {
          const p = marcador.getPosition();
          aoMudarRef.current(String(p.lat()), String(p.lng()));
        });
        mapa.addListener('click', (e) => {
          marcador.setPosition(e.latLng);
          marcador.setMap(mapa);
          aoMudarRef.current(String(e.latLng.lat()), String(e.latLng.lng()));
        });
        mapaRef.current = mapa;
        marcadorRef.current = marcador;
      })
      .catch(() => vivo && aoFalhar && aoFalhar());
    return () => {
      vivo = false;
      if (marcadorRef.current) marcadorRef.current.setMap(null);
      mapaRef.current = marcadorRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chave]);

  // coordenadas mudaram de fora (CEP/busca de endereço/edição manual): reposiciona
  useEffect(() => {
    const mapa = mapaRef.current;
    const marcador = marcadorRef.current;
    if (!mapa || !marcador || !temPonto) return;
    const atual = marcador.getPosition();
    if (!atual || Math.abs(atual.lat() - lat) > 1e-9 || Math.abs(atual.lng() - lng) > 1e-9 || !marcador.getMap()) {
      marcador.setPosition({ lat, lng });
      marcador.setMap(mapa);
      mapa.setCenter({ lat, lng });
      if ((mapa.getZoom() || 0) < 16) mapa.setZoom(16);
    }
  }, [lat, lng, temPonto]);

  return <div ref={divRef} style={{ height: 320, width: '100%', borderRadius: 6 }} />;
}
